import React, { useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../helpers";
import { FTPSearchBar } from "../../../../components-new";
import Fuse from "fuse.js";
import { RequestTypeTable } from "./request-type-table";
import RequestTypeCard from "./request-type-card";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, Checkbox, ListItemText } from "@mui/material";

const SEARCH_KEYS = [
    "type.name",
    "type.category",
    "type.subcategory",
    "type.display.text",
    "type.description.text",
    "type.tags",
];

export const RequestTypesHome = observer(() => {
    const { serviceRequestsStore } = useStore();
    const { meta } = serviceRequestsStore;

    const [searchQuery, setSearchQuery] = useState("");
    const [isTableView, setIsTableView] = useState(false);

    const [selectedCategory, setSelectedCategory] = useState<string[]>([]);
    const [selectedName, setSelectedName] = useState<string[]>([]);

    const { t } = useTranslation("service_request_settings");

    const data = meta?.type || [];

    const categoryOptions = [
        // @ts-ignore
        ...new Set(data.map((item) => item?.type?.category).filter(Boolean)),
    ];

    const nameOptions = [
        // @ts-ignore
        ...new Set(data.map((item) => item?.type?.name).filter(Boolean)),
    ];

    const filteredData = useMemo(() => {
        let result = data;

        if (selectedCategory.length > 0) {
            result = result.filter((item) =>
                // @ts-ignore
                selectedCategory.includes(item?.type?.category)
            );
        }

        if (selectedName.length > 0) {
            result = result.filter((item) =>
                // @ts-ignore
                selectedName.includes(item?.type?.name)
            );
        }

        return result;
    }, [data, selectedCategory, selectedName]);

    const fuse = useMemo(() => {
        return new Fuse(filteredData, {
            keys: SEARCH_KEYS,
            includeScore: true,
            threshold: 0.3,
        });
    }, [filteredData]);

    const searchResults = searchQuery
        ? fuse.search(searchQuery)
        : filteredData.map((item) => ({ item }));

    const handleCategoryChange = (event: any) => {
        const { value } = event.target;
        setSelectedCategory(
            typeof value === "string" ? value.split(",") : value
        );
    };

    const handleNameChange = (event: any) => {
        const { value } = event.target;
        setSelectedName(typeof value === "string" ? value.split(",") : value);
    };

    return (
        <>
            <div className="my-6 flex items-center justify-between gap-6">
                {!isTableView ? (
                    <div className="flex w-full items-center gap-4">
                        {/* Search */}
                        <FTPSearchBar
                            onSearch={(val) => setSearchQuery(val)}
                            placeHolder={t("request_type_search_request_type")}
                            clientSideSearch={false}
                        />
                    </div>
                ) : (
                    <p></p>
                )}

                <button
                    className="rounded-xl bg-black p-4 font-bold text-white"
                    onClick={() => setIsTableView(!isTableView)}
                >
                    {t("switch_to")}{" "}
                    {isTableView ? t("card_view") : t("table_view")}
                </button>
            </div>

            {isTableView ? (
                <RequestTypeTable />
            ) : (
                <RequestTypeCard searchdata={searchResults} />
            )}
        </>
    );
});
